import React from "react";
import { useDispatch } from "react-redux";
import { add } from "../../redux/slices/supplier";
import Fab from "../ui/Fab";

const AddSupplier = () => {
  const dispatch = useDispatch();
  return <Fab onClick={() => dispatch(add(true))} label="Νέος προμηθευτής" />;
};

export default AddSupplier;
